"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var asynciterator_1 = require("asynciterator");
/**
 * A {@link TransformIterator} that allows the source to be set through a lazy Promise.
 * The provided getter will only be called from the moment that this proxy iterator is being read.
 *
 * Rejections of the promise will be emitted as error event.
 */


var PromiseProxyIterator =
/*#__PURE__*/
function (_asynciterator_1$Tran) {
  _inherits(PromiseProxyIterator, _asynciterator_1$Tran);

  function PromiseProxyIterator(sourceGetter, options) {
    var _this;

    _classCallCheck(this, PromiseProxyIterator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromiseProxyIterator).call(this, options || {
      autoStart: false
    }));
    _this.sourceGetter = sourceGetter;
    return _this;
  }

  _createClass(PromiseProxyIterator, [{
    key: "_read",
    value: function _read(count, done) {
      var _this2 = this;

      if (!this.source) {
        this.sourceGetter().then(function (source) {
          _this2.source = source;

          _get(_getPrototypeOf(PromiseProxyIterator.prototype), "_read", _this2).call(_this2, count, done);
        }).catch(function (error) {
          return _this2.emit('error', error);
        });
      } else {
        _get(_getPrototypeOf(PromiseProxyIterator.prototype), "_read", this).call(this, count, done);
      }
    }
  }]);

  return PromiseProxyIterator;
}(asynciterator_1.TransformIterator);

exports.PromiseProxyIterator = PromiseProxyIterator;